// Strings for the onboarding screens brought over from the app (pinto). One namespace
// per file so features can be edited independently; merged in parity/index.ts.
// Copy mirrors pinto/i18n/translations.ts (deal-mode, paywall.*, setup.*,
// scanning_screen.*, more_stores.*). Params use {{name}}.
export const onboardingEn = {
  onboarding2: {
    // Welcome (pinto deal-mode)
    welcome_title: "Deals from stores near you",
    welcome_cta: "Set up my stores",
    welcome_hint: "Pick your stores, then choose a plan.",
    sign_out: "Sign out",
    back: "Back",
    close: "Close",
    log_out: "Log out",

    // ZIP step
    zip_title: "What's your ZIP code?",
    zip_sub: "We'll find the stores near you.",
    zip_label: "ZIP CODE",
    zip_continue: "See plans",
    zip_show_deals: "Show my deals",

    // Store preview (between ZIP and plan)
    preview_own_title: "{{count}} deals at your Walmart",
    preview_own_sub: "50% off or more at {{address}}. Unlock aisles and stock.",
    preview_nearby_title: "{{count}} deals at {{stores}} Walmarts near you",
    preview_nearby_title_one: "{{count}} deals at a Walmart near you",
    preview_nearby_sub: "All within {{miles}} miles, 50% off or more. Unlock aisles and stock.",
    preview_nearby_sub_pro: "All within {{miles}} miles. Pro covers all {{stores}}, with aisles and stock.",
    preview_cta_deals: "See all {{count}} deals",
    preview_leads_title: "We don't scan stores near you yet",
    preview_leads_sub: "Join and we start scanning the Walmarts near you right away. We'll let you know the moment your first deals are in.",
    preview_cta_leads: "Start scanning my stores",
    preview_leads_banner: "Meanwhile, here's what members found at Walmarts nationwide this week.",
    preview_top_lead: "Top lead · {{pct}}% off",
    preview_todays_leads: "Today's top leads",
    preview_new_today: "{{count}} new today",
    preview_check_stock: "Check stock",
    preview_stores_chip: "{{count}} stores",
    preview_aisle: "Aisle",
    zip_invalid: "Please enter a valid 5-digit ZIP code.",
    zip_no_stores: "No stores within 100 miles of that ZIP. Try a different ZIP code.",
    language_label: "Language",

    // Plan step (Y2)
    hero_title: "Local clearance,",
    hero_accent: "up to 97% off.",
    choose_plan_label: "CHOOSE YOUR PLAN",
    offer_badge: "{{pct}}% off your first month",
    most_popular: "MOST POPULAR",
    change: "Change",
    continue_plan: "Continue with {{plan}}",
    free_link: "Not now, browse online deals free",
    free_skip_title_count: "Skip {{count}} deals at your {{retailer}}?",
    free_skip_title: "Skip the deals at your stores?",
    free_skip_body: "Free is online deals only. In-store clearance prices, aisle and stock stay locked, and that clearance sells out to the members who can see it.",
    free_skip_keep: "Keep my store deals",
    free_skip_confirm: "Continue with online deals only",
    plan_basic_list: "1 home store + 4 extra nearby · Walmart and Home Depot",
    plan_plus_list: "Up to 3 home stores + 7 extra · 9 chains · penny items",
    plan_pro_list: "Up to 5 home stores + 10–15 extra · Hawk Finds · what items resell for",
    plan_basic_short: "1 store + 4 extra",
    plan_plus_short: "3 stores + 7 extra",
    plan_pro_short: "5 stores + 10–15 extra",
    plan_basic_desc: "1 home store + 4 extra nearby · Walmart and Home Depot",
    plan_plus_desc: "Up to 3 home stores + 7 extra at Walmart and Home Depot · 9 chains · penny items",
    plan_pro_desc: "Up to 5 home stores + 15 extra at Walmart (10 at Home Depot) · Hawk Finds · what items resell for",
    stores_explainer:
      "Home stores are the ones you pick. Extra stores are the closest Walmart and Home Depot stores around them, with a lighter daily scan for clearance and markdowns.",
    per_month: "/month",
    intro_then: "{{intro}} first month, then {{full}}",
    first_month_then: "1st month, then {{full}}",
    fine_intro_then: "{{intro}} for the first month, then {{price}}/mo. Cancel anytime.",
    cancel_anytime: "Cancel anytime.",
    terms: "Terms",
    privacy: "Privacy",
    sheet_title: "Choose your plan",
    sheet_offer: "Every plan is {{pct}}% off for the first month only.",
    auto_renew: "Auto-renews at the price and billing period shown until cancelled in Settings.",
    retailer_disclaimer:
      "DealHawk is an independent service and is not affiliated with, endorsed by, or officially connected to any retailer featured on the platform.",
    secure_checkout: "Secure payment via Stripe",
    active_plan_error:
      "You already have an active plan. Please manage billing to upgrade or cancel your existing plan.",

    // Store steps (paywall + more stores)
    stores_question_walmart: "Which Walmarts do you shop at?",
    stores_question_home_depot: "Which Home Depots do you shop at?",
    stores_hint: "Pick up to {{count}}. Closest first.",
    near: "Near {{zip}}",
    count: "{{count}} of {{limit}}",
    none: "No stores found near this ZIP code.",
    stores_load_error: "We couldn't load nearby stores. Check your connection and try again.",
    deals_now: "Deals now",
    deals_within_24h: "Deals within 24h",
    stores_pick_one: "Pick at least 1 store",
    stores_continue_one: "Continue with 1 store",
    stores_continue_n: "Continue with {{count}} stores",
    stores_checkout: "Continue to secure checkout",
    opening_checkout: "Opening secure checkout…",
    save_one: "Save 1 store",
    save_n: "Save {{count}} stores",
    select_store_error: "Please select at least one store.",
    save_failed: "Failed to save. Please try again.",
    checkout_failed: "Failed to start checkout. Please try again.",
    miles: "{{miles}} mi",

    // Checkout return
    activating: "Activating your account…",
    activating_sub: "Please wait while we set up your subscription.",
    pending_title: "Payment received",
    pending_sub: "We're still activating your account. This can take a moment.",
    go_to_deals: "Go to my deals",

    // You're in (pinto scanning)
    scanning_title_1: "You're in.",
    scanning_title_2: "Scanning your stores.",
    scanning_sub: "Local deals show up as each store's next scan completes. We'll notify you.",
    scanning_stores_one: "{{count}} store",
    scanning_stores_n: "{{count}} stores",
    scanning_status: "scanning",
    scanning_loading: "Loading your deals",

    // Where else do you shop? (pinto more-stores)
    more_title: "Where else do you shop?",
    more_sub: "Tap the stores you shop at and we'll find the ones near you.",
    more_included: "INCLUDED IN YOUR PLAN",
    more_select_all: "Select all",
    more_clear: "Clear",
    more_pick_one: "Pick at least 1",
    more_find_stores: "Find my stores for {{count}}",
    more_skip: "Skip for now",
    more_which_stores: "Which {{retailer}} stores do you shop at?",
    more_done: "Done",
    more_none_nearby: "No {{retailer}} stores within 100 miles of your ZIP.",
    more_skip_retailer: "Skip {{retailer}}",
    more_save_failed: "We couldn't save your stores. Please try again.",

    // Deals-first onboarding (ZIP → plans → not covered)
    dz_rating: "{{rating}} on the App Store",
    dz_title_1: "See the clearance",
    dz_title_2: "hiding near you",
    dz_sub: "Shelf prices, aisles and stock at the Walmart, Target, HD and Dollar General stores around your ZIP.",
    dz_placeholder: "ZIP code",
    dz_examples_alt: "Clearance deals members found",
    dp_title_own: "{{count}} clearance deals at your Walmart",
    dp_title_nearby: "{{count}} clearance deals at {{stores}} Walmarts",
    dp_title_nearby_one: "{{count}} clearance deals at 1 Walmart",
    dp_title_generic: "Unlock clearance at the stores near you",
    dp_chip_walmarts: "{{count}} Walmarts",
    dp_chip_walmarts_one: "1 Walmart",
    dp_chip_nationwide: "Nationwide",
    dp_chip_leads_week: "{{count}} found nationwide this week",
    dp_payback: "{{total}} in markdowns here today. {{count}} single finds each save more than a month of DealHawk.",
    dp_payback_total: "{{total}} in markdowns here today.",
    dp_aisle: "Aisle {{aisle}}",
    dp_left: "{{count}} left",
    dp_members_price: "Members price",
    dp_panel_title: "Unlock every price, aisle and stock count",
    dp_best_value: "BEST VALUE",
    dp_penny_prefix: "Every plan includes",
    dp_cta: "Start {{plan}} for {{price}}",
    dp_unlock_all: "Unlock all {{count}}",
    dp_unlock: "Unlock every price",
    dp_per_mo: "/mo",
    dp_offer_short: "{{pct}}% off month one",
    dp_examples: "Examples",
    dp_examples_from: "From Walmart in {{place}}",
    dp_examples_nationwide: "Spotted at Walmarts nationwide",
    dp_example_store: "Walmart · {{place}}",
    nc_title: "We don't scan stores near you yet",
    nc_sub: "Here's what members are finding in {{place}} this week, so you can see what it looks like. Online deals are free to browse anywhere.",
    nc_sub_short: "Here's what members find in {{place}} this week. Online deals are free anywhere.",
    nc_sub_generic: "Here's what members are finding this week, so you can see what it looks like. Online deals are free to browse anywhere.",
    nc_notify_title: "Get told when we add your stores",
    nc_notify_body: "We add new areas every week, starting with the ZIPs people ask for most. One email when yours goes live, nothing else.",
    nc_email_label: "Email",
    nc_notify_cta: "Notify me",
    nc_notify_done: "Thanks, we'll email you",
    nc_notify_done_body: "One email to {{email}} when stores near {{zip}} go live.",
    nc_notify_error: "We couldn't save that just now. Please try again later.",
    nc_email_invalid: "Enter a valid email address.",
    nc_closest: "Closest stores we scan",
    nc_browse_free: "Browse online deals free",
    nc_plan_prompt: "Live within an hour of these stores?",
    nc_plan_anyway: "Choose a plan anyway",
    nc_try_zip: "Try another ZIP",
    nc_store_walmart: "Walmart #{{id}}",
    nc_store_home_depot: "HD #{{id}}",
  },
} as const;

export const onboardingEs = {
  onboarding2: {
    welcome_title: "Ofertas de tiendas cerca de ti",
    welcome_cta: "Configurar mis tiendas",
    welcome_hint: "Elige tus tiendas y luego un plan.",
    sign_out: "Cerrar sesión",
    back: "Atrás",
    close: "Cerrar",
    log_out: "Cerrar sesión",

    zip_title: "¿Cuál es tu código postal?",
    zip_sub: "Buscaremos las tiendas cerca de ti.",
    zip_label: "CÓDIGO POSTAL",
    zip_continue: "Ver planes",
    zip_show_deals: "Ver mis ofertas",

    preview_own_title: "{{count}} ofertas en tu Walmart",
    preview_own_sub: "50% o más de descuento en {{address}}. Desbloquea pasillos e inventario.",
    preview_nearby_title: "{{count}} ofertas en {{stores}} Walmarts cerca de ti",
    preview_nearby_title_one: "{{count}} ofertas en un Walmart cerca de ti",
    preview_nearby_sub: "Todas a menos de {{miles}} millas, con 50% o más de descuento. Desbloquea pasillos e inventario.",
    preview_nearby_sub_pro: "Todas a menos de {{miles}} millas. Pro cubre las {{stores}}, con pasillos e inventario.",
    preview_cta_deals: "Ver las {{count}} ofertas",
    preview_leads_title: "Aún no escaneamos tiendas cerca de ti",
    preview_leads_sub: "Únete y empezamos a escanear los Walmarts cerca de ti de inmediato. Te avisamos en cuanto lleguen tus primeras ofertas.",
    preview_cta_leads: "Escanear mis tiendas",
    preview_leads_banner: "Mientras tanto, esto es lo que encontraron los miembros en Walmarts de todo el país esta semana.",
    preview_top_lead: "Mejor lead · {{pct}}% menos",
    preview_todays_leads: "Mejores leads de hoy",
    preview_new_today: "{{count}} nuevos hoy",
    preview_check_stock: "Ver inventario",
    preview_stores_chip: "{{count}} tiendas",
    preview_aisle: "Pasillo",
    zip_invalid: "Ingresa un código postal válido de 5 dígitos.",
    zip_no_stores: "No hay tiendas a menos de 100 millas de ese código postal. Prueba con otro.",
    language_label: "Idioma",

    hero_title: "Liquidación local,",
    hero_accent: "hasta 97% menos.",
    choose_plan_label: "ELIGE TU PLAN",
    offer_badge: "{{pct}}% menos el primer mes",
    most_popular: "MÁS POPULAR",
    change: "Cambiar",
    continue_plan: "Continuar con {{plan}}",
    free_link: "Ahora no, ver ofertas en línea gratis",
    free_skip_title_count: "¿Dejar pasar {{count}} ofertas en tu {{retailer}}?",
    free_skip_title: "¿Dejar pasar las ofertas de tus tiendas?",
    free_skip_body: "Gratis solo incluye ofertas en línea. Los precios de liquidación, el pasillo y las existencias en tienda quedan bloqueados, y esa liquidación se la llevan los miembros que sí la ven.",
    free_skip_keep: "Quedarme con mis ofertas",
    free_skip_confirm: "Seguir solo con ofertas en línea",
    plan_basic_list: "1 tienda principal + 4 extra cercanas · Walmart y Home Depot",
    plan_plus_list: "Hasta 3 tiendas principales + 7 extra · 9 cadenas · ofertas penny",
    plan_pro_list: "Hasta 5 tiendas principales + 10–15 extra · Hawk Finds · a cuánto se revende",
    plan_basic_short: "1 tienda + 4 extra",
    plan_plus_short: "3 tiendas + 7 extra",
    plan_pro_short: "5 tiendas + 10–15 extra",
    plan_basic_desc: "1 tienda principal + 4 tiendas extra cercanas · Walmart y Home Depot",
    plan_plus_desc: "Hasta 3 tiendas principales + 7 extra en Walmart y Home Depot · 9 cadenas · ofertas penny",
    plan_pro_desc: "Hasta 5 tiendas principales + 15 extra en Walmart (10 en Home Depot) · Hawk Finds · a cuánto se revende cada producto",
    stores_explainer:
      "Las tiendas principales son las que tú eliges. Las tiendas extra son los Walmart y Home Depot más cercanos a ellas, con un escaneo diario más ligero de liquidaciones y rebajas.",
    per_month: "/mes",
    intro_then: "{{intro}} el primer mes, luego {{full}}",
    first_month_then: "1.er mes, luego {{full}}",
    fine_intro_then: "{{intro}} el primer mes, luego {{price}}/mes. Cancela cuando quieras.",
    cancel_anytime: "Cancela cuando quieras.",
    terms: "Términos",
    privacy: "Privacidad",
    sheet_title: "Elige tu plan",
    sheet_offer: "Todos los planes tienen {{pct}}% de descuento solo el primer mes.",
    auto_renew: "Se renueva automáticamente al precio y periodo indicados hasta que lo canceles en Ajustes.",
    retailer_disclaimer:
      "DealHawk es un servicio independiente y no está afiliado, respaldado ni conectado oficialmente con ninguna tienda que aparece en la plataforma.",
    secure_checkout: "Pago seguro con Stripe",
    active_plan_error:
      "Ya tienes un plan activo. Administra tu facturación para mejorar o cancelar tu plan actual.",

    stores_question_walmart: "¿En qué Walmart compras?",
    stores_question_home_depot: "¿En qué Home Depot compras?",
    stores_hint: "Elige hasta {{count}}. Las más cercanas primero.",
    near: "Cerca de {{zip}}",
    count: "{{count}} de {{limit}}",
    none: "No encontramos tiendas cerca de este código postal.",
    stores_load_error: "No pudimos cargar las tiendas cercanas. Revisa tu conexión e inténtalo de nuevo.",
    deals_now: "Ofertas ahora",
    deals_within_24h: "Ofertas en 24 h",
    stores_pick_one: "Elige al menos 1 tienda",
    stores_continue_one: "Continuar con 1 tienda",
    stores_continue_n: "Continuar con {{count}} tiendas",
    stores_checkout: "Continuar al pago seguro",
    opening_checkout: "Abriendo el pago seguro…",
    save_one: "Guardar 1 tienda",
    save_n: "Guardar {{count}} tiendas",
    select_store_error: "Elige al menos una tienda.",
    save_failed: "No se pudo guardar. Inténtalo de nuevo.",
    checkout_failed: "No se pudo abrir el pago. Inténtalo de nuevo.",
    miles: "{{miles}} mi",

    activating: "Activando tu cuenta…",
    activating_sub: "Espera mientras configuramos tu suscripción.",
    pending_title: "Pago recibido",
    pending_sub: "Todavía estamos activando tu cuenta. Puede tardar un momento.",
    go_to_deals: "Ir a mis ofertas",

    scanning_title_1: "¡Listo!",
    scanning_title_2: "Revisando tus tiendas.",
    scanning_sub: "Las ofertas locales aparecen cuando termina la revisión de cada tienda. Te avisaremos.",
    scanning_stores_one: "{{count}} sucursal",
    scanning_stores_n: "{{count}} sucursales",
    scanning_status: "revisando",
    scanning_loading: "Cargando tus ofertas",

    more_title: "¿Dónde más compras?",
    more_sub: "Toca las tiendas donde compras y buscaremos las que están cerca.",
    more_included: "INCLUIDAS EN TU PLAN",
    more_select_all: "Elegir todas",
    more_clear: "Quitar",
    more_pick_one: "Elige al menos 1",
    more_find_stores: "Continuar con {{count}}",
    more_skip: "Ahora no",
    more_which_stores: "¿En qué {{retailer}} compras?",
    more_done: "Listo",
    more_none_nearby: "No hay tiendas {{retailer}} a menos de 100 millas de tu código postal.",
    more_skip_retailer: "Omitir {{retailer}}",
    more_save_failed: "No pudimos guardar tus tiendas. Inténtalo de nuevo.",

    dz_rating: "{{rating}} en la App Store",
    dz_title_1: "Descubre las liquidaciones",
    dz_title_2: "escondidas cerca de ti",
    dz_sub: "Precios en estante, pasillos e inventario en los Walmart, Target, HD y Dollar General cerca de tu código postal.",
    dz_placeholder: "Código postal",
    dz_examples_alt: "Liquidaciones que encontraron los miembros",
    dp_title_own: "{{count}} liquidaciones en tu Walmart",
    dp_title_nearby: "{{count}} liquidaciones en {{stores}} Walmarts",
    dp_title_nearby_one: "{{count}} liquidaciones en 1 Walmart",
    dp_title_generic: "Desbloquea las liquidaciones de las tiendas cerca de ti",
    dp_chip_walmarts: "{{count}} Walmarts",
    dp_chip_walmarts_one: "1 Walmart",
    dp_chip_nationwide: "En todo el país",
    dp_chip_leads_week: "{{count}} encontradas en todo el país esta semana",
    dp_payback: "{{total}} en rebajas aquí hoy. {{count}} hallazgos por sí solos ahorran más de un mes de DealHawk.",
    dp_payback_total: "{{total}} en rebajas aquí hoy.",
    dp_aisle: "Pasillo {{aisle}}",
    dp_left: "Quedan {{count}}",
    dp_members_price: "Precio para miembros",
    dp_panel_title: "Desbloquea cada precio, pasillo e inventario",
    dp_best_value: "MEJOR VALOR",
    dp_penny_prefix: "Todos los planes incluyen",
    dp_cta: "Empezar {{plan}} por {{price}}",
    dp_unlock_all: "Desbloquea las {{count}}",
    dp_unlock: "Desbloquea cada precio",
    dp_per_mo: "/mes",
    dp_offer_short: "{{pct}}% menos el primer mes",
    dp_examples: "Ejemplos",
    dp_examples_from: "De Walmart en {{place}}",
    dp_examples_nationwide: "Vistas en Walmarts de todo el país",
    dp_example_store: "Walmart · {{place}}",
    nc_title: "Aún no escaneamos tiendas cerca de ti",
    nc_sub: "Esto es lo que los miembros encuentran en {{place}} esta semana, para que veas cómo se ve. Las ofertas en línea son gratis en cualquier lugar.",
    nc_sub_short: "Esto encuentran los miembros en {{place}} esta semana. Las ofertas en línea son gratis en cualquier lugar.",
    nc_sub_generic: "Esto es lo que los miembros encuentran esta semana, para que veas cómo se ve. Las ofertas en línea son gratis en cualquier lugar.",
    nc_notify_title: "Te avisamos cuando lleguemos a tus tiendas",
    nc_notify_body: "Agregamos zonas nuevas cada semana, empezando por los códigos postales más pedidos. Un solo correo cuando la tuya esté lista, nada más.",
    nc_email_label: "Correo",
    nc_notify_cta: "Avísame",
    nc_notify_done: "Gracias, te escribiremos",
    nc_notify_done_body: "Un correo a {{email}} cuando lleguemos a las tiendas cerca de {{zip}}.",
    nc_notify_error: "No pudimos guardarlo ahora. Inténtalo más tarde.",
    nc_email_invalid: "Escribe un correo válido.",
    nc_closest: "Tiendas más cercanas que escaneamos",
    nc_browse_free: "Ver ofertas en línea gratis",
    nc_plan_prompt: "¿Vives a menos de una hora de estas tiendas?",
    nc_plan_anyway: "Elegir un plan de todos modos",
    nc_try_zip: "Probar otro código postal",
    nc_store_walmart: "Walmart #{{id}}",
    nc_store_home_depot: "HD #{{id}}",
  },
} satisfies { onboarding2: Record<keyof (typeof onboardingEn)["onboarding2"], string> };
